export const APP_LONG_NAME="TALI N'NA MINI ZO0 PARC";
export const APP_DESC="Application de gestion des du parc Zoo TALI N'NA";